import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import MUICustomTabs from "src/components/GeneralComponents/MUICustomTabs";
import MissionLevelDetail from "./MissionLevelDetail";
import Community from "../Community/Community";
import { mission_detail_api } from "src/DAL/Missions/Missions";
import ActiveLastBreadcrumb from "src/components/BreadCrums";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function MissionDetailNew() {
  const { mission_id, level_id } = useParams();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingfirst, setIsLoadingfirst] = useState(true);
  const [missionDetail, setMissionDetail] = useState({});
  let value = Number(localStorage.getItem("tabValuesMission"));
  const [tabValue, setTabValue] = useState(value || 0);
  const [missionSchedules, setMissionSchedules] = useState(null);
  const [missionBadges, setMissionBadges] = useState([]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem("tabValuesMission", newValue);
  };

  const get_mission_detail = async () => {
    const result = await mission_detail_api(mission_id);
    if (result.code == 200) {
      setMissionDetail(result.mission);
      setMissionBadges(result.badge_configration);
      setIsLoading(false);
      setIsLoadingfirst(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
      setIsLoadingfirst(false);
    }
  };

  const TABS_OPTIONS = [
    {
      title: "Mission Overview",
      component: (
        <MissionLevelDetail
          hideHeading={true}
          missionSchedules={missionSchedules}
          missionBadges={missionBadges}
          missionDetail={missionDetail}
        />
      ),
    },
    {
      title: "Community",
      component: (
        <>
          {isLoading ? (
            <CircularProgress className={classes.loading} color="primary" />
          ) : (
            <div className="mt-3">
              <Community list_type="mission" event_id={mission_id} />
            </div>
          )}
        </>
      ),
    },
  ];

  let breadCrumbMenu = [
    {
      title: "Mission Levels",
      navigation: `/mission-levels`,
    },
    {
      title:
        missionDetail?.membership_level_info?.badge_level_info?.tagline ||
        "Levels",
      navigation: `/mission-levels/${level_id}`,
    },
    {
      title: missionDetail.title,
      navigation: ``,
      active: true,
    },
  ];

  useEffect(() => {
    get_mission_detail(tabValue);
  }, []);

  if (isLoadingfirst) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <div className="container-fluid">
        <div className="mission-level-heading">
          <ActiveLastBreadcrumb breadCrumbMenu={breadCrumbMenu} />
        </div>
        <div className="row mobile-margin">
          <div
            className="col-12 mt-2 d-block  level-icons position-relative "
            style={{ zIndex: "999" }}
          >
            <MUICustomTabs
              data={TABS_OPTIONS}
              value={tabValue}
              handleChange={handleChange}
              className="challenge-video-detail-tabs"
            />
          </div>
        </div>
      </div>
    </>
  );
}
